<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="420"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_seventeenData'"
    :sqOptions="[ 35, 53]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesSeventeen',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 84)
      } else if (value === 2) {
        this.$emit('handleProgress', 83)
      } else if (value === 3) {
        this.$emit('handleProgress', 83)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
